import Drawable from '../entities/Drawable.js';
import PixelText from './PixelText.js';
import OptionsBox from './OptionsBox.js';
import { imageStore, spriteStore } from '../images.js';
import { globalItemDataStore } from '../OverworldAnimation.js';
export default class BagMenu extends Drawable {
    constructor({ visible = false, position = { x: 0, y: 0 }, stateMachine }) {
        super();
        this.stateMachine = stateMachine;
        this.visible = visible;
        this.position = position;
        this.sprites = {
            background: spriteStore.store.bagMenuBackgroundSprite,
            leftArrow: spriteStore.store.leftArrowSprite,
            rightArrow: spriteStore.store.rightArrowSprite,
            bagIcon: spriteStore.store.bagIconSprite,
            selectedItemArrow: spriteStore.store.selectedItemArrowSprite,
            selectedItemIcon: spriteStore.store.selectedItemIconSprite,
            bagOptionsBox: new OptionsBox({
                position: { x: 176, y: 96 },
                visible: false,
                options: ['Use', 'Cancel'],
            }),
        };

        this.navigationBarText = new PixelText({
            text: 'ITEMS',
            position: { x: this.position.x + 44, y: this.position.y + 8 },
            color: PixelText.whiteTextColor,
            shadowColor: PixelText.blackShadowColor,
        });

        this.item0Text = new PixelText({
            text: 'Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item1Text = new PixelText({
            text: 'Super Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item2Text = new PixelText({
            text: 'Hyper Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item3Text = new PixelText({
            text: 'Max Potion',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item4Text = new PixelText({
            text: 'Full Restore',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item5Text = new PixelText({
            text: 'Antidote',
            position: { x: this.position.x + 96, y: this.position.y + 16 },
            color: 'black',
        });

        this.item0Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item1Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item2Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item3Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item4Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.item5Amount = new PixelText({
            text: 'x3',
            position: {
                x: this.position.x + 240 - 16,
                y: this.position.y + 16,
            },
            color: 'black',
            textAlign: 'right',
        });

        this.itemDescription = new PixelText({
            text: '',
            position: { x: this.position.x + 40, y: this.position.y + 118 },
            maxWidth: 200,
            color: PixelText.whiteTextColor,
            shadowColor: PixelText.blackShadowColor,
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }

        this.navigationBarText.textAlign = 'center';
        this.navigationBarText.text = this.stateMachine.bagMenu.getCurrentPageTitle();
        this.sprites.bagIcon.frames.val = this.currentPage % 3;
        this.sprites.background.draw();
        this.navigationBarText.draw();
        this.sprites.bagIcon.draw();
        this.sprites.leftArrow.draw();
        this.sprites.rightArrow.draw();

        let itemId = '';
        let currentWindow;
        let selectedItemIndexInWindow;
        let attempts = 0;
        while (itemId === '') {
            currentWindow = this.stateMachine.bagMenu.getCurrentWindow();
            selectedItemIndexInWindow = this.stateMachine.bagMenu.getIndexInCurrentWindow();
            itemId = currentWindow[selectedItemIndexInWindow]
                ? `${currentWindow[selectedItemIndexInWindow].id}`
                : '';
            if (itemId === '') {
                this.stateMachine.bagMenu.currentOptionArray[this.stateMachine.bagMenu.currentPage] -= 1;
                this.stateMachine.bagMenu.updateWindowPosition();
            }
            attempts += 1;
            if (attempts > 5) {
                this.stateMachine.bagMenu.currentOptionArray[this.stateMachine.bagMenu.currentPage] = 0;
                break;
            }
        }

        if (currentWindow.length === 0) {
            return;
        }

        currentWindow.forEach((item, index) => {
            const itemText = this[`item${index}Text`];
            itemText.text = `${item.name}`;
            itemText.position.y = this.position.y + 12 + 16 * index;
            itemText.draw();
            const itemAmountText = this[`item${index}Amount`];
            itemAmountText.text = `x${`${item.quantity}`.padStart(4, ' ')}`;
            itemAmountText.position.y = this.position.y + 12 + 16 * index;
            itemAmountText.draw();
        });

        this.sprites.selectedItemArrow.position.x = 88;
        this.sprites.selectedItemArrow.position.y = 12 + 16 * selectedItemIndexInWindow;
        this.sprites.selectedItemArrow.draw();

        this.sprites.selectedItemIcon.setImage(imageStore.get(`img/items/${itemId}.png`));
        this.sprites.selectedItemIcon.draw();
        this.itemDescription.text = globalItemDataStore[itemId]?.description || '';
        this.itemDescription.draw();
        this.sprites.bagOptionsBox.draw();
    }
}
